import { required, unique, shape, items, concatFailure, logTo, atLeastOne, fromParent, when } from '@totalsoft/pure-validations';

export const reportValidator = shape({
  orderNumber: required,
  reportName: required,
  reportFriendlyName: required,
  reportXPartnerTypes: fromParent(parent => [atLeastOne, required |> items] |> concatFailure |> when(parent.showInPartner)),
  reportXDocumentTypes: fromParent(parent => [atLeastOne, required |> items] |> concatFailure |> when(parent.showInDocument))
});

export const reportParameterValidator =
  concatFailure(
    items(
      shape({
        paramName: required,
        reportParameterTypeId: required
      })
    )
  ) |> logTo(console);

export const reportFilterValidator = concatFailure(
  unique(x => x.orderNo || {}, 'Reports.ReportFilters.Validators.OrderNoUnique'),
  items(
    shape({
      orderNo: required,
      filterCode: required,
      filterCaption: required,
      filterTypeId: required
    })
  )
);
